import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

@Component({
  selector: 'visitor-legal-terms',
  templateUrl: './visitor-legal-terms.component.html',
  styleUrls: ['./visitor-legal-terms.component.scss'],
})
export class VisitorLegalTermsComponent implements OnInit, OnDestroy {
  //AEM content variables
  marketHoldingTermsDisclaimer: AEMChunk
  aemContentSub: Subscription

  constructor(private readonly centralContentService: CentralContentService) {}

  ngOnInit(): void {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.marketHoldingTermsDisclaimer =
      this.centralContentService.getContentByBody(
        'disclaimer_money_market_holding_terms_and_conditions',
        content,
      )
  }
  @Output() userAction = new EventEmitter<boolean>()
  userAccepted() {
    this.userAction.emit(true)
  }
  userDeclined() {
    this.userAction.emit(false)
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
